import getListViewStore from "owa-mail-list-store/lib/store/Store";
import folderIdToName from "owa-session-store/lib/utils/folderIdToName";

export function doesItemExistInOutbox(itemId: string): boolean {
    for (const tableView of getListViewStore().tableViews.values()) {
        if (folderIdToName(tableView.tableQuery.folderId) === "outbox" &&
            tableView.rowIdToRowKeyMap.has(itemId)) {
            return true;
        }
    }
    return false;
}
